import { Form, Select, Button, Radio, Col, Tooltip, Row, Input } from "antd";
import {
  AuthTitleBlock,
  DetailFields,
  DownArrowDraw,
  HaberForm,
} from "../../Pages/styledElements";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../Pages/pageStyled";
import { ModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import { useContext, useEffect, useState } from "react";
import { getReelCoreValues } from "../../Services/settingsServices";
import styled from "styled-components";
import Multiselect from "multiselect-react-dropdown";
import { getUnitData } from "../../Services/measurementService";
import JobCardDataContext from "../../ContextApi/JobCardDataContext";
import { editToleranceForOrderSummary } from "../../Services/deckleMatchServices";
const { Option } = Select;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
  },
};

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
  .ant-btn {
    border: 0px solid transparent !important;
  }
`;

export const ToleranceResetModal = ({
  visible,
  groupId,
  onClickSetToleranceButton,
  setAppliedReelODLevel,
  showToaster,
  setActionToaster,
  refresh,
  groupData,
  setGlobalTolerance,
  ordersIdList,
  globalTolerance,
  setShowAlert,
  showAlert
}) => {

  const { setOrderSummaryTable } = useContext(JobCardDataContext);
  const [reelValues, setReelValues] = useState([]);
  const [reelODLevel, setReelODLevel] = useState("JobCard");
  const [reelODType, setReelODType] = useState("Constant");
  const [selectedReelOD, setSelectedReelOD] = useState([]);
  const [measurementData, setMeasurementData] = useState();
  const saveTolerance = async () => {
    const lower_bound = parseFloat(form.getFieldValue("lower_bound"));
    const upper_bound = parseFloat(form.getFieldValue("upper_bound"));
    // const strOrders = ordersIdList.map(String);
    const strOrders = ordersIdList.map((item) => {
      if (typeof item === "string" || typeof item === "number") {
        return String(item).replace("PSTOCK-DYNAMIC-", "").replace(".0", "");
      }
      return item;
    });
    const type_selected = form.getFieldValue("tolerance_level_type");
    let data = type_selected === "Order" ? {
             group: groupId,
        type: "reset",
        upper_tolerance: null,
        lower_tolerance: null,
        order: strOrders,
        units: { weight: "t" },
      } : {
      group: groupId,
      type: "jobcard_level",
      upper_tolerance: upper_bound,
      lower_tolerance: lower_bound,
      order: strOrders,
      units: { weight: "t" },
    };
    await editToleranceForOrderSummary(data)
      .then((response) => {
        //   updateGroupRecords(lower_bound, upper_bound);
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved`,
        });
        setGlobalTolerance({
          lower: lower_bound,
          upper: upper_bound,
        });
        refresh();
        onClickSetToleranceButton(false);
        if(type_selected === "Order"){
          setShowAlert((prev) => ({
            ...prev,
             isOrderChanged  : false,
             isToleranceChanged : false,
             isGlobalToleranceChanged : false,
             toleranceLevel: type_selected,
          }))
        }
        else if(showAlert.isGlobalToleranceChanged&&(showAlert.isOrderChanged||showAlert.isToleranceChanged)){
           setShowAlert((prev) => ({
            ...prev,
             isOrderChanged  : false,
             isToleranceChanged : false,
             isGlobalToleranceChanged : true,
             toleranceLevel: type_selected,
          }))
        }
        else{        
        setShowAlert((prev) => ({
          ...prev,
          isGlobalToleranceChanged: true,
          toleranceLevel: type_selected,
          isOrderChanged: false,
          isToleranceChanged: false,
        }));
        }
      })
      .catch((error) => {
        setActionToaster({
          error: error?.response?.data?.error,
          msg: error?.response?.data?.msg,
        });
      });
  };

  const cancelAction = () => {
    onClickSetToleranceButton(false);
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
  };

  const removeReelOD = (data) => {
    setSelectedReelOD(
      selectedReelOD.filter((item) => data.value != item.value)
    );
  };

  const [form] = Form.useForm();

  const reelType = [
    {
      label: "Constant",
      value: "Constant",
    },
    {
      label: "Range",
      value: "Range",
    },
  ];

  const fetchReelDias = async () => {
    try {
      const response = await getReelCoreValues();
      setReelValues(
        response.reel_data.map((item) => ({ value: item[0] + " " + item[1] }))
      );
    } catch (e) {
      console.log(e);
    }
  };
  const fetchUnitsData = async () => {
    try {
      const data = await getUnitData();
      if (!data.error) {
        setMeasurementData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchReelDias();
    fetchUnitsData();
  }, []);
  return (
    <ModalPopup visible={visible} style={{ width: "335px" }}>
      <div className="resetPassForm removePadLeft">
        <DetailFields className="marginBtnP" style={{ paddingBottom: "15px" }}>
          <div className="header">
            <h3>Job Card Level Tolerance</h3>
          </div>
          <HaberForm>
            <Form
              name="JobCardReelOD"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              form={form}
              onFinish={() => {}}
            >
              <div
                className="drawerField"
                style={{
                  borderBottom: "0px solid #edebe9",
                }}
              >
                <Form.Item
                  className=" switchRadio twoSwitch"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                  }}
                  name="tolerance_level_type"
                  initialValue={'JobCard'}
                >
                  <Radio.Group
                    options={["JobCard", "Order"]}
                    optionType="button"
                    buttonStyle="solid"
                    value={reelODLevel}
                    onChange={(e) => setReelODLevel(e.target.value)}
                  />
                </Form.Item>
                {reelODLevel == "JobCard" && (
                  <div>
                    <Col style={{ paddingBottom: "15px" }}>
                      <Row>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span>Enter Lower Bound</span>
                        </Col>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="boxFormType">
                            <Form.Item
                              name="lower_bound"
                              className="selectForm"
                              initialValue={globalTolerance?.lower}
                              style={{ marginBottom: "0px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  validator: (_, value) => {
                                    if (parseFloat(value) <= 0) {
                                      return Promise.reject(
                                        "Should be non-zero positive number"
                                      );
                                    }
                                    if (!/^\d+(\.\d{1,3})?$/.test(value)) {
                                      return Promise.reject(
                                        "Only up to 3 decimal digits allowed"
                                      );
                                    }
                                    if (parseFloat(value) > 100) {
                                      return Promise.reject(
                                        "Should be less than equal to 100"
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder="LB"
                                className="inputField"
                                style={{ paddingLeft: "10px" }}
                              />
                            </Form.Item>

                            <span className="nonEditable">%</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span
                            style={{
                              marginLeft: "3px",
                              fontSize: "14px",
                            }}
                          >
                            Enter Upper Bound
                          </span>
                        </Col>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="boxFormType">
                            <Form.Item
                              name="upper_bound"
                              className="selectForm"
                              initialValue={globalTolerance?.upper}
                              dependencies={["lower_bound"]} // <-- enables cross-field validation
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  validator: (_, value, callback) => {
                                    const lower =
                                      form.getFieldValue("lower_bound");
                                    if (parseFloat(value) <= 0) {
                                      return Promise.reject(
                                        "Should be non-zero positive number"
                                      );
                                    }
                                    // if (
                                    //   parseFloat(value) <= parseFloat(lower)
                                    // ) {
                                    //   return Promise.reject(
                                    //     "Upper bound should be greater than lower bound"
                                    //   );
                                    // }
                                    if (!/^\d+(\.\d{1,3})?$/.test(value)) {
                                      return Promise.reject(
                                        "Only up to 3 decimal digits allowed"
                                      );
                                    }
                                    if (parseFloat(value) > 100) {
                                      return Promise.reject(
                                        "Should be less than equal to 100"
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                              style={{ marginBottom: "0px" }}
                            >
                              <Input
                                placeholder="UB"
                                className="inputField"
                                style={{ paddingLeft: "10px" }}
                              />
                            </Form.Item>

                            <span className="nonEditable">%</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </div>
            </Form>
          </HaberForm>
        </DetailFields>
      </div>
      <div className="ant-modal-footer-section">
        <Button key="submit" className="themeBtn" onClick={saveTolerance}>
          <Iconmoon icon="edit" size={14} color="#ffff" />
          Save
        </Button>
        <Button
          key="back"
          className="themeBtn-plane"
          onClick={onClickSetToleranceButton}
        >
          <div className="plusPopUpBorder">
            <Iconmoon
              icon="plus-sign"
              size={9}
              color="#EA655B"
              className="ant-ico-sec"
            />
          </div>
          Cancel
        </Button>
      </div>
    </ModalPopup>
  );
};
